module.exports = __webpack_public_path__ + "fonts/GothamSSm-Medium.0f026bcf.eot";